// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"47806042","311":"b89c2bf0","485":"f76665b6","519":"a1c6b519","615":"1bf4f190","779":"3745b5c2"}[chunkId] + ".chunk.js";
};